import axios from "./api";

// 提交用户信息
export const submitForm = (params) => {
    return axios.request({
        url: "/cxregister",
        method: "post",
        data: params,
        header: {
            'Content-Type':'application/json'
        }
    })
};

// 获取地市资源
export const listbygrade = (params) => {
    return axios.request({
        url: "/common/listallbygrade",
        method: "get",
        data: params
    })
}

// 获取微信分享信息
export const getShareInfo = (params) => {
    return axios.request({
        url: "/common/getShareInfo",
        method: "post",
        data: params,
        header: {
            'Content-Type':'application/json'
        }
    })
}


// WEBPACK FOOTER //
// ./src/http/info.js